import { SystemListModel } from "@iewc/Types/CustomApiModels";
import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomSystemListStateType {
    readonly [key: string]: SystemListModel[];
}

export type CustomSystemListState = Readonly<CustomSystemListStateType>;

export const initialCustomSystemListState: CustomSystemListState = {};

export const customSystemListReducer = createTypedReducer(initialCustomSystemListState, {
    "Custom/SystemList/SetSystemListByKey": (
        draft: Draft<CustomSystemListState>,
        { key, value }: { key: string; value: SystemListModel[] },
    ) => ({
        ...draft,
        [key]: value,
    }),
});
